module.exports = __webpack_public_path__ + "static/media/lujon.3a22a78c.mp3";